import { render } from "./vatrate.vue?vue&type=template&id=775c1930&scoped=true&ts=true"
import script from "./vatrate.vue?vue&type=script&lang=ts"
export * from "./vatrate.vue?vue&type=script&lang=ts"

import "./vatrate.vue?vue&type=style&index=0&id=775c1930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775c1930"]])

export default __exports__